import { getShipmentInfoFromStops, dateFormatter, stopRenderer, warningRenderer } from '../utils';

const ES_SO_template = (SO) => {
  const { data, costQuote } = SO;
  const { start_time_from, end_time_to, shipper, stops, extras, id, total_weight } = data;
  const { net_full_cost } = costQuote;
  const { company_name } = shipper;

  const country = 'ES';

  const when = dateFormatter(start_time_from, end_time_to, country);
  const stopsToRender = stopRenderer(stops, country).join('');
  const warning = warningRenderer(extras, country);
  const stopsInfo = getShipmentInfoFromStops(stops, country);

  return `
    ¿Quieres este trabajo?

    COBRAS
    ${net_full_cost} € IVA no incl.

    CUANDO
    ${when}

    EMPRESA
    ${company_name}

    ${stopsInfo.shipmentType}
    ${stopsInfo.PICKUP} Recogida(s), ${stopsInfo.DROPOFF} Entrega(s)
    Peso total ${total_weight} Kg
    ${stopsToRender}
    ${warning}

    Responde a este mensaje escribiendo LO QUIERO
    Nº de referencia: ${id}
  `;
};

export default ES_SO_template;
